import ScrollableBar from './scrollable-bar';
import Item from './item';

ScrollableBar.Item = Item;

export default ScrollableBar;
